import { useTheme } from '@/components/ThemeProvider';
import { Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { formatBalanceWithCommas, formatPercentage, formatTextEllipsis } from '@/lib/format';
import { cn, genJudgingSizeColor } from '@/lib/utils';
import CopyNode from '@/widget/CopyNode';
import { Reload, Share } from '@/widget/Icon';
import { useBoomWallet } from '@boomeme/wallet-sdk';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppStore } from '@/store';
import { useAddressProfit } from '@/hooks/api/useAddressProfit';

type TIME = '7d' | '30d';
export default () => {
  const { fwClass, totalBalance } = useAppStore();
  const { walletAddress } = useBoomWallet();
  const { theme } = useTheme();
  const { t } = useTranslation();
  const { profit, setTimeRange } = useAddressProfit();
  const [_, setShareOpen] = useState(false);

  return (
    <>
      <div className="flex justify-between mb-[24px] mt-[12px]">
        <div className="flex flex-col gap-y-[6px]">
          <span className={cn('text-[14px]', fwClass)}>{formatTextEllipsis(walletAddress || '', 4, 4)}</span>
          <h1 className={cn('text-[24px]', fwClass)}>{formatBalanceWithCommas(totalBalance)}</h1>
          <div className="flex items-center  gap-x-[6px]">
            <span className={cn('text-[12px] font-[400]', genJudgingSizeColor(profit.pnl))}>
              {formatBalanceWithCommas(profit.pnl)}({formatPercentage(profit.roi, { scale: true })})
            </span>
            <div>
              <Select onValueChange={(e: string) => setTimeRange(e as TIME)}>
                <SelectTrigger className="h-[22px] px-[4px] pl-[8px] py-[2px] bg-primaryBgColor rounded-[6px]">
                  <SelectValue
                    className="bg-[#fff] w-full h-full text-[12px] font-[400] border-[1px] border-[#E4E4E7] dark:border-[#27272A]"
                    placeholder={t('Token.7D')}
                  />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectItem value="7d">{t('Token.7D')}</SelectItem>
                    <SelectItem value="30d">{t('Token.30D')}</SelectItem>
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>
          </div>
        </div>
        <div className="flex gap-x-[12px]">
          <Reload theme={theme} onClick={() => window.location.reload()} />
          <CopyNode text={walletAddress || ''} />
          <Share theme={theme} onClick={() => setShareOpen(true)} />
        </div>
      </div>
      {/* <AccountShare isOpen={shareOpen} onOpenChange={setShareOpen} profitInfo={profitInfo} /> */}
    </>
  );
};
